import api from './api';

export interface CurrentUserResponse {
  id: number;
  email?: string;
  walletAddress?: string;
  name?: string;
  surname?: string;
  refId?: number | null;
  refCode: string;
}

export interface ReferralUser {
  id: number;
  email?: string;
  walletAddress?: string;
  name?: string;
  surname?: string;
  registeredAt: string;
  refId?: number | null;
  refCode: string;
}

export const fetchCurrentUser = async (): Promise<CurrentUserResponse> => {
  const response = await api.get<CurrentUserResponse>('/user/profile');
  return response.data;
};

export const fetchReferrals = async (): Promise<ReferralUser[]> => {
  const response = await api.get<ReferralUser[]>('/user/referrals');
  return response.data;
};

export const updateLastAction = async (): Promise<void> => {
  await api.post('/user/ula');
};
